module.exports = __webpack_public_path__ + "images/erp-nation-glad-top-2026.1787648603550.png";